import { render } from "./ViewDepartmentUsers.vue?vue&type=template&id=604fe67e&scoped=true"
import script from "./ViewDepartmentUsers.vue?vue&type=script&lang=js"
export * from "./ViewDepartmentUsers.vue?vue&type=script&lang=js"

import "./ViewDepartmentUsers.vue?vue&type=style&index=0&id=604fe67e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604fe67e"]])

export default __exports__